export const PATIENT_READINGS_PAGE_SIZE = 6;
export const TODAY_APPOINTMENTS_PAGE_SIZE = 5;
export const TODAY_HISTORY_ACTIVITIES_PAGE_SIZE = 5;

export const HistoricalActivityTypes = {
  ReadingReview: 'readingReview',
  VoiceCall: 'voiceCall',
  Sms: 'sms',
  ClinicalNote: 'clinicalNote',
  ClinicalNoteManual: 'clinicalNoteManual',
  KeyNote: 'keyNote',
  Medication: 'medication',
  Condition: 'condition',
  AppointmentBooked: 'appointmentBooked',
  AppointmentRescheduled: 'appointmentRescheduled',
} as const;

export type THistoricalActivityType =
  (typeof HistoricalActivityTypes)[keyof typeof HistoricalActivityTypes];
